export default __webpack_public_path__ + "static/media/Companyprofile.d8c0bf2f.png";